import DefaultNotificationModal from '../DefaultNotificationModal';
import { useState } from 'react';
import Routes from 'src/constants/Routes';
import classNames from 'classnames';
import { Vertical } from 'src/constants/Verticals';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import { env } from 'src/env.mjs';
import { usePathname } from 'next/navigation';

type clickTrackingProps = {
    title: string;
    vertical: Vertical;
};

type DisclaimerProps = {
    darkMode?: boolean;
    className?: string;
} & Partial<clickTrackingProps>;

const Disclaimer = ({
    darkMode = false,
    title,
    vertical,
    className,
}: DisclaimerProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const pathname = usePathname();
    return (
        <span
            className={classNames('p3', className, {
                'text-green-faint-light': darkMode,
                'text-grey-400': !darkMode,
            })}
        >
            By clicking “Continue&quot;, you confirm that you are at least 18
            years old and eligible to use this service, and you consent to
            telehealth, our{' '}
            <button
                type="button"
                className="cursor-pointer underline"
                onClick={() => {
                    setIsModalOpen(true);
                    trackClick(EventNames.MODAL_OPENED, {
                        path: pathname,
                        brand: env.NEXT_PUBLIC_BRAND,
                        label: 'Default notifications settings',
                        title,
                        vertical,
                        url: window.location.href,
                    });
                }}
            >
                Default notifications settings,
            </button>{' '}
            and agree to our{' '}
            <a className="underline" href={Routes.TERMS_OF_USE}>
                Terms & Conditions
            </a>{' '}
            and{' '}
            <a className="underline" href={Routes.PRIVACY_POLICY}>
                Privacy Policy.
            </a>
            <DefaultNotificationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
            />
        </span>
    );
};
export default Disclaimer;
